import React, { useState } from "react";
import { FaPencilAlt } from "react-icons/fa";

const AddHeadingSection = ({ 
  headings = [], 
  onAdd, 
  onUpdate, 
  maxHeadings = 250 
}) => {
  const [inputValue, setInputValue] = useState("");
  const [editingHeading, setEditingHeading] = useState(null);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleAddOrUpdate = () => {
    if (inputValue.trim() !== "") {
      if (editingHeading !== null) {
        // Update existing heading - pass old title and new title
        onUpdate(editingHeading.name, inputValue.trim());
        setEditingHeading(null);
      } else {
        // Add new heading
        onAdd(inputValue.trim());
      }
      setInputValue("");
    }
  };

  const handleToggleEdit = (heading) => {
    setEditingHeading(heading);
    setInputValue(heading.name);
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex gap-8 items-start">
        {/* Left side - Headings display area */}
        <div className="flex-shrink-0 w-[45%]">
          {/* <div className="inline-flex items-center gap-2 bg-green-600 text-white px-4 py-2 rounded-md mb-4">
            <span className="font-medium">Heading</span>
            <FaPencilAlt className="text-sm" />
          </div> */}
          
          {/* Scrollable headings area */}
          <div className="custom-scrollbar overflow-x-hidden flex flex-wrap h-64 rounded-md p-3 gap-x-2 gap-y-2 bg-gray-100 overflow-y-auto">
            {headings?.map((heading) => (
              <div
                key={heading.id}
                className="bg-green-600 h-8 rounded-lg px-3 text-sm font-normal text-white flex items-center gap-2"
              >
                <span>{heading.name}</span>
                <button
                  className="focus:outline-none"
                  onClick={() => handleToggleEdit(heading)}
                >
                  {editingHeading?.id === heading.id ? (
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 26 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.08333 22.9167H5.10208L18.95 9.06875L16.9312 7.05L3.08333 20.8979V22.9167ZM0.25 25.75V19.7292L18.95 1.06458C19.2333 0.804861 19.5462 0.604167 19.8885 0.4625C20.2309 0.320833 20.591 0.25 20.9688 0.25C21.3465 0.25 21.7125 0.320833 22.0667 0.4625C22.4208 0.604167 22.7278 0.816667 22.9875 1.1L24.9354 3.08333C25.2188 3.34306 25.4253 3.65 25.5552 4.00417C25.6851 4.35833 25.75 4.7125 25.75 5.06667C25.75 5.44444 25.6851 5.80451 25.5552 6.14687C25.4253 6.48924 25.2188 6.80208 24.9354 7.08542L6.27083 25.75H0.25ZM17.9229 8.07708L16.9312 7.05L18.95 9.06875L17.9229 8.07708Z"
                        fill="#fff"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 26 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.08333 22.9167H5.10208L18.95 9.06875L16.9312 7.05L3.08333 20.8979V22.9167ZM0.25 25.75V19.7292L18.95 1.06458C19.2333 0.804861 19.5462 0.604167 19.8885 0.4625C20.2309 0.320833 20.591 0.25 20.9688 0.25C21.3465 0.25 21.7125 0.320833 22.0667 0.4625C22.4208 0.604167 22.7278 0.816667 22.9875 1.1L24.9354 3.08333C25.2188 3.34306 25.4253 3.65 25.5552 4.00417C25.6851 4.35833 25.75 4.7125 25.75 5.06667C25.75 5.44444 25.6851 5.80451 25.5552 6.14687C25.4253 6.48924 25.2188 6.80208 24.9354 7.08542L6.27083 25.75H0.25ZM17.9229 8.07708L16.9312 7.05L18.95 9.06875L17.9229 8.07708Z"
                        fill="#fff"
                      />
                    </svg>
                  )}
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Right side - Input and Add button */}
        <div className="flex-1">
          <div className="flex gap-3 mb-2">
            <input
              type="text"
              value={inputValue}
              maxLength={50}
              onChange={handleInputChange}
              placeholder="Enter Meeting Heading"
              className="flex-1 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  handleAddOrUpdate();
                }
              }}
            />
            <button
              onClick={handleAddOrUpdate}
              className="bg-green-600 hover:bg-green-700 text-white px-8 py-2 rounded-md font-medium transition-colors"
            >
              {editingHeading !== null ? "Done" : "Add"}
            </button>
          </div>
          
          {/* Helper text and counter */}
          <div className="flex flex-col gap-2 mt-4">
            <p className="text-sm text-gray-500">
              Add Heading like: Client Meeting, Office Meeting etc.
            </p>
            <p className="text-sm text-gray-600 text-right">
              {headings.length}/{maxHeadings} Heading used
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddHeadingSection;
